export default "__VITE_ASSET__78bd0912__"